import { graphql } from 'react-relay/legacy';

export const error404RootQuery = graphql`
    query error404RootQuery($showModules: Boolean = true) {
        viewer {
            ...Error404Layout_viewer
        }
    }
`;
